<template>
  <div class="status-container">
    <div class="status-hint" data-type="danger">
      <span class="status-hint__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7ZM12 15C12.5523 15 13 15.4477 13 16V16.001C13 16.5533 12.5523 17.001 12 17.001C11.4477 17.001 11 16.5533 11 16.001V16C11 15.4477 11.4477 15 12 15Z" fill="currentColor"></path>
        </svg>
      </span>
      <span class="status-hint__heading-text">发票已过期</span>
      <p class="status-hint__description">请创建新发票</p>
    </div>
  </div>
  <button  class="btn" @click="this.$router.go(-1)" >取消</button>
</template>

<script>
export default {
  name: "checkStatus"
}
</script>

<style scoped lang="scss">
.status-container{
  padding: 0 32px;
  margin-bottom: 5vw;
  .status-hint[data-type=danger] {
    background-color: #ff1a2d1f;
    .status-hint__icon{
      color:#ff3d4d;
    }
  }
  .status-hint{
    border-radius: 12px;
    display: grid;
    gap: 6px 12px;
    grid-template-columns: auto 1fr;
    padding: 12px;
    .status-hint__icon{
      height: 24px;
      width: 24px;
    }
    .status-hint__heading-text{
      color: #000;
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
    }
    .status-hint__description{
      color: #000;
      font-size: 16px;
      font-weight: 400;
      grid-column: 2;
      letter-spacing: -.12px;
      line-height: 24px;
    }
  }
}
.btn {
  margin-top: -5vw;
  margin-left: 5vw;
  margin-bottom: 5vw;
  height: 13.3vw;
  padding: 18px 24px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
  line-height: 20px;
  width: 90%;
  cursor: pointer;
  background-color: #000;
  color: #fff;
}
</style>
